import {
  Address,
  AddressModel,
  Billing,
  BillingModel,
  Contact,
  ContactModel,
  DomainModelHelper,
  EntityBase,
} from '@digital-platform/shared/domain';
import { Generator } from '../interfaces/generator.interface';

export class GeneratorModel extends EntityBase implements Generator {
  constructor(config?: Generator) {
    super(config);
    this.schemaVersion = config
      ? config.schemaVersion
        ? config.schemaVersion
        : 1
      : 1;
    this.version = config ? (config.version ? config.version : null) : 1;
    this.id = config
      ? DomainModelHelper.ensureDataIsString(config.id)
      : GeneratorModel.DEFAULT_CONFIG.id;
    this.active = config ? (config.active ? config.active : true) : true;
    this.name = config ? (config.name ? config.name : '') : '';
    this.customerName = config
      ? DomainModelHelper.ensureDataIsString(config.customerName) || ''
      : GeneratorModel.DEFAULT_CONFIG.customerName;
    this.parentCustomerName = config
      ? DomainModelHelper.ensureDataIsString(config.parentCustomerName) ||
        this.customerName
      : GeneratorModel.DEFAULT_CONFIG.parentCustomerName;
    this.naicsNumber = config
      ? DomainModelHelper.ensureDataIsString(config.naicsNumber)
      : null;
    this.regulatoryIdNumberNotApplicable = config
      ? DomainModelHelper.ensureDataIsBoolean(
          config.regulatoryIdNumberNotApplicable
        )
      : null;
    this.isMailingAddressSameAsSite = config
      ? DomainModelHelper.ensureDataIsBoolean(config.isMailingAddressSameAsSite)
      : null;

    this.isCustomer3rdParty = config
      ? DomainModelHelper.ensureDataIsBoolean(config.isCustomer3rdParty)
      : null;
    this.is3rdPartyAuthorized = config
      ? DomainModelHelper.ensureDataIsBoolean(config.is3rdPartyAuthorized)
      : null;

    this.isCustomer3rdParty = config
      ? DomainModelHelper.ensureDataIsBoolean(config.isCustomer3rdParty)
      : null;

    this.isOneTimeOnly = config
      ? DomainModelHelper.ensureDataIsBoolean(config.isOneTimeOnly)
      : false;

    this.isEditable = config
      ? DomainModelHelper.ensureDataIsBoolean(config.isEditable)
      : false;

    this.epaId = config
      ? DomainModelHelper.ensureDataIsString(config.epaId)
      : GeneratorModel.DEFAULT_CONFIG.epaId;
    this.regulatoryIdNumber = config
      ? DomainModelHelper.ensureDataIsString(config.regulatoryIdNumber)
      : null;
    this.billing = config ? this.createBilling(config.billing) : null;
    this.contact = config ? this.createContact(config.contact) : null;
    this.generatorAddress = config
      ? this.createAddress(config.generatorAddress)
      : null;
    this.siteAddress = config ? this.createAddress(config.siteAddress) : null;
  }

  public static DEFAULT_CONFIG: Generator = {
    schemaVersion: 1,
    version: 1,
    active: true,
    id: '',
    name: '',
    customerName: '',
    naicsNumber: '',
    regulatoryIdNumberNotApplicable: false,
    isMailingAddressSameAsSite: false,
    isCustomer3rdParty: null,
    is3rdPartyAuthorized: null,
    isOneTimeOnly: false,
    isEditable: true,
    parentCustomerName: null,
    regulatoryIdNumber: '',
    epaId: '',
    generatorAddress: AddressModel.DEFAULT_CONFIG,
    siteAddress: AddressModel.DEFAULT_CONFIG,
    contact: ContactModel.DEFAULT_CONFIG,
    billing: BillingModel.DEFAULT_CONFIG,
  };
  readonly schemaVersion: 1;
  readonly version: number;
  readonly active: boolean;
  readonly id: string | null;
  readonly name: string;
  readonly customerName: string;
  readonly naicsNumber: string;
  readonly regulatoryIdNumberNotApplicable: boolean;
  readonly isMailingAddressSameAsSite: boolean;
  readonly isCustomer3rdParty: boolean;
  readonly is3rdPartyAuthorized: boolean;
  readonly isOneTimeOnly: boolean;
  readonly isEditable: boolean;
  readonly parentCustomerName: string;
  readonly regulatoryIdNumber: string;
  readonly epaId: string;
  readonly billing: Billing;
  readonly contact: Contact | null;
  readonly generatorAddress: Address;
  readonly siteAddress: Address;

  public static hydrate(data: Generator): GeneratorModel {
    let { customerName } = data || { customerName: null };

    if (Array.isArray(customerName)) {
      customerName = customerName[0] || null;
    }

    return new GeneratorModel({
      ...GeneratorModel.DEFAULT_CONFIG,
      ...data,
      customerName,
    });
  }

  protected createBilling(billingConfig: Billing) {
    return billingConfig ? new BillingModel(billingConfig) : null;
  }

  protected createAddress(addressConfig: Address) {
    return addressConfig ? new AddressModel(addressConfig) : null;
  }

  protected createContact(contactConfig: Contact) {
    return contactConfig ? new ContactModel(contactConfig) : null;
  }
}
